import { render, staticRenderFns } from "./CompetitionWriteDefaultLayout.vue?vue&type=template&id=11a20958&scoped=true&"
import script from "./CompetitionWriteDefaultLayout.vue?vue&type=script&lang=js&"
export * from "./CompetitionWriteDefaultLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a20958",
  null
  
)

export default component.exports